import { buildAccountDonateUrl } from "./links";
import { getAccountUserAvatar, normalizeAccountUser } from "./user";

const isObject = (value) => value && typeof value === "object";

const toFiniteNumber = (value, fallback = 0) => {
  const number = Number(value);
  return Number.isFinite(number) ? number : fallback;
};

export const normalizeAccountProfile = (profile) => {
  if (!isObject(profile)) {
    return null;
  }

  return {
    ...profile,
    balance: toFiniteNumber(profile.balance, 0),
  };
};

export const getAccountBalance = (user, profile = null) => {
  const normalizedProfile = normalizeAccountProfile(profile);

  if (normalizedProfile) {
    return normalizedProfile.balance;
  }

  return toFiniteNumber(user?.balance, 0);
};

export const applyOptimisticBalance = (profile, newBalance) => {
  if (!isObject(profile)) {
    return profile;
  }

  const nextBalance = Number(newBalance);

  if (!Number.isFinite(nextBalance)) {
    return profile;
  }

  return {
    ...profile,
    balance: nextBalance,
  };
};

export const getAccountProfileErrorMessage = (
  error,
  fallback = "Failed to load profile",
) =>
  error?.response?.data?.message ||
  error?.response?.data?.error ||
  error?.message ||
  fallback;

export const createAccountSummary = ({
  user,
  profile,
  fallbackAvatar = null,
  donateBaseUrl,
} = {}) => {
  const normalizedUser = normalizeAccountUser(user);
  const normalizedProfile = normalizeAccountProfile(profile);

  return {
    user: normalizedUser,
    profile: normalizedProfile,
    username: normalizedUser.username,
    displayName: normalizedUser.displayName,
    avatar: getAccountUserAvatar(normalizedUser, fallbackAvatar),
    balance: getAccountBalance(normalizedUser, normalizedProfile),
    donateUrl: buildAccountDonateUrl(normalizedUser, donateBaseUrl),
    steamId: normalizedUser.steamId,
    isStaff: normalizedUser.isStaff,
    isAuthenticated: normalizedUser.isAuthenticated,
  };
};
